const resultFunction = (experiments, variants) =>
  Object.fromEntries(Object.entries(variants).filter(([name]) => experiments[name]?.enabled))

const enabledExperimentsSelectorDefinition = {
  id: 'enabledExperiments',
  resultFunction,
  dependencies: [{ selector: 'experiments' }, { selector: 'variants' }],
}

export default enabledExperimentsSelectorDefinition
